// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5877":"089a0f9390fa5f1c","6686":"21f2f5bd66630236","9056":"bd89b27939c1a35b"}[chunkId] + ".js";
};